export const environment = {
  production: true,
  staging: false,
  development: false,
  HOST_URL: "https://api-gifthub.360customizer.com",
  BASE_URL: "http://gifthub.360customizer.com",
  OFFICIAL_SITE_URL: "https://360customizer.com",
  GIFTHUB_API_VERSION: "V1",
  PRODUCT_BRIDGE_HOST_URL: "https://api-productbridge.360customizer.com",
  PRODUCT_BRIDGE_API_VERSION: "v1",
  ELVA_HOST_URL: "https://360ai-hub.360customizer.com",
  ELVA_API_VERSION: "v1",
  APP_CDN_URL: "https://360customizer.360customizer.com",
  GOOGLE_CLIENT_ID:
    "242043938779-kga14vupgg5drfvkuqu33sggavkm25kd.apps.googleusercontent.com",
  MAXIMUM_GENERATION_LIMIT: "10",
  GIFTHUB_PRODUCTS_PROCESSING_LIMIT: "30",
  VITE_APP_APPLICATION_NAME: "360GiftHub",
  S3_FOLDER_NAME: "gifthub",
};
